module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Electric/Range-hood-93d3106136d43c19186f646b8549f1ce.svg";